//상품이력 조회

import BaseModal from "components/modal/base";
import { useGetProductHistoryData } from "./service";
import { useTranslation } from "react-i18next";
import Grid from "components/grid";

type IProps = {
  isOpen: boolean;
  onClose: () => void;
};
export default function ProductHistoryModal({ isOpen, onClose }: IProps) {
  const { t } = useTranslation();
  const { rowData } = useGetProductHistoryData();

  const cellstyle = (params: any) => {
    if (params.colDef.field === "histStaTypNm") {
      const color =
        params.data.histStaTyp === "D"
          ? "#d90429"
          : params.data.histStaTyp === "C"
          ? "#38b000"
          : params.data.histStaTyp === "U"
          ? "#001f3d"
          : "#2b2d42";

      return {
        color: color,
      };
    }

    return {};
  };
  return (
    <>
      <BaseModal
        title={t("md_ttl_rmpd_hst")}
        styles={"w-full"}
        isOpen={isOpen}
        onClose={onClose}
      >
        <Grid
          pagination={true}
          theads={theads}
          rowData={rowData}
          cellstyle={cellstyle}
          pageNav={null}
        />
      </BaseModal>
    </>
  );
}

const theads = [
  {
    langNm: "grid_no",
    type: "id",
    field: "No",
    width: 60,
  },
  {
    langNm: "grid_rmpd_no",
    type: "string",
    field: "rmNo",
    width: 120,
  },
  {
    langNm: "grid_status",
    type: "string",
    field: "histStaTypNm",
    width: 90,
  },
  {
    langNm: "grid_rmpd_ct",
    type: "number",
    field: "rmPdCt",
    width: 90,
  },
  {
    langNm: "grid_able_sell_ct",
    type: "number",
    field: "sellYCt",
    width: 100,
  },
  {
    langNm: "grid_rmpd_sell_n_ct",
    type: "number",
    field: "sellNCt",
    width: 100,
  },
  {
    langNm: "grid_sell_amt",
    type: "price",
    field: "rmSellAmt",
    width: 100,
  },
  {
    langNm: "grid_acsr_no",
    type: "string",
    field: "acsrNo",
    width: 100,
  },
  {
    langNm: "grid_memo",
    type: "string",
    field: "memo",
  },
];
